import React, { useState, useEffect } from 'react';
import { useAuth, API } from '../context/AuthContext';
import axios from 'axios';
import { toast } from 'sonner';

const Dashboard = () => {
  const { user, token } = useAuth();
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPurchases();
  }, []);

  const fetchPurchases = async () => {
    try {
      const response = await axios.get(`${API}/purchases`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPurchases(response.data);
    } catch (error) {
      toast.error('Kon nie aankoopgeskiedenis laai nie');
    } finally {
      setLoading(false);
    }
  };

  const getStatusLabel = (status) => {
    const labels = {
      pending: 'Hangend',
      completed: 'Voltooi',
      failed: 'Misluk',
      cancelled: 'Gekanselleer'
    };
    return labels[status] || status;
  };

  const getTypeLabel = (type) => {
    const labels = {
      digital: 'Digitaal',
      physical: 'Fisies',
      both: 'Beide'
    };
    return labels[type] || type;
  };

  return (
    <div className="min-h-screen py-24 md:py-32 px-6 md:px-12">
      <div className="container mx-auto max-w-5xl">
        <h1 className="font-heading text-4xl md:text-5xl font-normal tracking-tight text-charcoal mb-16 text-center">
          U Biblioteek
        </h1>

        {/* User Info */}
        <div data-testid="user-info" className="bg-parchment border border-[#E5E0D6] p-8 mb-12">
          <h2 className="font-heading text-2xl font-medium italic mb-4 text-charcoal">
            Welkom, {user?.name}
          </h2>
          <p className="font-body text-lg text-muted-charcoal">
            {user?.email}
          </p>
        </div>

        {/* Purchases */}
        <div>
          <h2 className="font-heading text-3xl font-medium italic mb-8 text-charcoal">
            Aankoopgeskiedenis
          </h2>

          {loading ? (
            <p className="font-body text-lg text-muted-charcoal text-center py-12">
              Besig om te laai...
            </p>
          ) : purchases.length === 0 ? (
            <div className="bg-surface/30 border border-[#E5E0D6] p-12 text-center">
              <p className="font-body text-lg text-muted-charcoal mb-6">
                U het nog nie die boek gekoop nie.
              </p>
              <a
                href="/purchase"
                data-testid="cta-purchase-from-dashboard"
                className="inline-block bg-charcoal text-parchment hover:bg-charcoal/80 rounded-sm px-8 py-4 font-ui uppercase tracking-widest text-sm transition-colors duration-300"
              >
                Skaf die Boek aan
              </a>
            </div>
          ) : (
            <div className="space-y-6">
              {purchases.map((purchase) => (
                <div
                  key={purchase.purchase_id}
                  data-testid={`purchase-${purchase.purchase_id}`}
                  className="bg-parchment border border-[#E5E0D6] p-8 hover:border-gold transition-colors duration-300"
                >
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <h3 className="font-heading text-xl font-medium italic text-charcoal">
                        {getTypeLabel(purchase.purchase_type)}
                      </h3>
                      <p className="font-body text-sm text-muted-charcoal">
                        {new Date(purchase.created_at).toLocaleDateString('af-ZA', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                      </p>
                    </div>
                    <div className="text-right">
                      <p className="font-heading text-2xl text-gold">
                        R{purchase.amount.toFixed(2)}
                      </p>
                      <p className={`font-ui text-xs uppercase tracking-widest ${
                        purchase.payment_status === 'completed' ? 'text-green-700' : 'text-muted-charcoal'
                      }`}>
                        {getStatusLabel(purchase.payment_status)}
                      </p>
                    </div>
                  </div>

                  {purchase.payment_status === 'completed' && 
                   (purchase.purchase_type === 'digital' || purchase.purchase_type === 'both') && (
                    <a
                      href="/reader"
                      data-testid="cta-read-book"
                      className="inline-block border border-charcoal text-charcoal hover:bg-charcoal hover:text-parchment rounded-sm px-6 py-3 font-ui uppercase tracking-widest text-xs transition-colors duration-300"
                    >
                      Lees die Boek
                    </a>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
